<template>
  <div style="width: 100%">
    <md-card>
      <md-card-header
        style="margin-bottom: 30px"
        class="md-card-header-text md-card-header-green"
      >
        <div class="card-text">
          <h4 class="title">الفلتر</h4>
        </div>
      </md-card-header>
      <md-card-content>
        <div
          v-for="(repeat, index) in repeaterForm"
          :key="index"
          class="card-content-flex"
        >
          <div class="mt-25 ml-15" style="width: 40%">
            <md-field>
              <label>اسم العامود</label>
              <v-select
                style="width: 100%"
                dir="rtl"
                :reduce="(item) => item"
                label="arabicName"
                v-model="repeat.filter"
                :options="
                  col_pdf.filter((item) =>
                    privateCompanyMode
                      ? item.privateCompanyMode === privateCompanyMode
                      : item
                  )
                "
                placeholder="اسم العامود"
                clearable
              ></v-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-30 mt-25 ml-15">
            <md-field v-if="repeat.filter && repeat.filter.type == 'enum'">
              <label>{{ repeat.filter.arabicName }}</label>
              <md-select v-model="repeat.value">
                <md-option
                  v-for="item in repeat.filter.values"
                  :key="item.title"
                  :value="item.value"
                >
                  {{ item.title }}
                </md-option>
              </md-select>
            </md-field>

            <md-field v-if="repeat.filter && repeat.filter.type == 'request'">
              <label>{{ repeat.filter.arabicName }}</label>
              <md-select v-model="repeat.value">
                <md-option
                  v-for="item in repeat.filter.values"
                  :key="item.name"
                  :value="item.name"
                >
                  {{ item.name }}
                </md-option>
              </md-select>
            </md-field>

            <md-field
              v-else-if="repeat.filter && repeat.filter.type === 'text'"
            >
              <label>{{ repeat.filter.arabicName }}</label>
              <md-input v-model="repeat.value"></md-input>
            </md-field>
            <md-field
              v-else-if="repeat.filter && repeat.filter.type === 'number'"
            >
              <label>{{ repeat.filter.arabicName }}</label>
              <md-input type="number" v-model="repeat.value"></md-input>
            </md-field>
            <md-field
              v-else-if="repeat.filter && repeat.filter.type === 'integer'"
            >
              <label>{{ repeat.filter.arabicName }}</label>
              <md-input type="number" v-model="repeat.value"></md-input>
            </md-field>
            <div
              v-else-if="repeat.filter && repeat.filter.type === 'fromTo'"
              class="date-from-to"
            >
              <div class="md-layout-item md-size-50">
                <md-datepicker :md-open-on-focus="false" v-model="repeat.value">
                  <label class="mr-28">من تاريخ</label>
                </md-datepicker>
              </div>

              <div class="md-layout-item md-size-50">
                <md-datepicker
                  :md-open-on-focus="false"
                  v-model="repeat.value2"
                >
                  <label class="mr-28">الى تاريخ</label>
                </md-datepicker>
              </div>
            </div>
            <md-field
              v-else-if="repeat.filter && repeat.filter.type === 'request'"
            >
              <label>{{ repeat.filter.arabicName }}</label>
              <md-input type="number" v-model="repeat.value"></md-input>
            </md-field>
          </div>

          <md-button
            v-if="index == repeaterForm.length - 1"
            class="md-success md-just-icon"
            @click="increaseToForm"
          >
            <md-icon>add</md-icon>
          </md-button>

          <md-button
            class="md-danger md-just-icon"
            :disabled="index < 1"
            @click="removeFromForm(index)"
          >
            <md-icon>remove</md-icon>
          </md-button>
        </div>
      </md-card-content>
    </md-card>

    <div
      class="md-layout-item md-size-100 mt-25 mtb-25"
      style="text-align: center"
    >
      <md-button @click="search" class="md-success btn_nanosoft">بحث</md-button>
      <md-button class="md-success btn_nanosoft" @click="clear">
        افراغ
      </md-button>
      <md-button @click="printExcel" class="md-info btn_nanosoft">
        طباعة Excel
      </md-button>

      <md-button @click="printPdf" class="md-info btn_nanosoft">
        طباعة PDF
      </md-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../../env.js";
export default {
  data() {
    return {
      filter: null,
      privateCompanyMode: false,
      repeaterForm: [
        {
          filter: "",
          value: null,
          value2: new Date(),
        },
      ],
      col_pdf: [
        {
          arabicName: "التصنيف الوظيفي",
          enName: "JobtitelClassification",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "موظف",
              value: "موظف",
            },
            {
              title: "مدير إدارة",
              value: "مدير إدارة",
            },
            {
              title: "رئيس قسم",
              value: "رئيس قسم",
            },
            {
              title: "رئيس وحدة",
              value: "رئيس وحدة",
            },
            {
              title: "مدير عام",
              value: "مدير عام",
            },
          ],
        },
        {
          arabicName: "نوع التوظيف",
          enName: "JobTypeString",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "تعيين",
              value: "تعيين",
            },
            {
              title: "عقد",
              value: "عقد",
            },
            {
              title: "ندب",
              value: "ندب",
            },
            {
              title: "إعارة",
              value: "إعارة",
            },
            {
              title: "عقد مصنف",
              value: "عقد مصنف",
            },
            {
              title: "عقد متعاون",
              value: "عقد متعاون",
            },
          ],
        },
        {
          arabicName: "طريقة شغل الوظيفة",
          enName: "JobDescriptionString",
          privateCompanyMode: false,
          type: "enum",
          values: [
            {
              title: "لا يوجد",
              value: "",
            },
            {
              title: "منتقل",
              value: "منتقل",
            },
            {
              title: "تنسيب",
              value: "تنسيب",
            },
          ],
        },
        {
          arabicName: "رقم جواز السفر",
          enName: "PassportNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "مكان اصدار جواز السفر",
          enName: "PassportIssuePlace",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        // {
        //   arabicName: "تاريخ اصدار جواز السفر",
        //   enName: "PassportIssueDate",
        // privateCompanyMode: true,
        //   type: "fromTo",
        //   values: null,
        // },
        {
          arabicName: "سنة الحصول على المؤهل ",
          enName: "ScientificAppointmentYear",
          privateCompanyMode: true,
          type: "integer",
          values: null,
        },
        {
          arabicName: "الدوام الرسمي",
          enName: "ShiftName",
          privateCompanyMode: true,
          type: "request",
          api: "api/Shifts",
          values: null,
        },
        {
          arabicName: "الدوام الثاني",
          enName: "SecondaryShiftName",
          privateCompanyMode: true,
          type: "request",
          api: "api/Shifts",
          values: null,
        },
        {
          arabicName: "الدوام الثالث",
          enName: "ThirdShiftName",
          privateCompanyMode: true,
          type: "request",
          api: "api/Shifts",
          values: null,
        },
        {
          arabicName: "المؤهل العلمي",
          enName: "ScientificDegreeName",
          privateCompanyMode: true,
          type: "request",
          api: "api/scientific-degrees",
          values: null,
        },
        {
          arabicName: "الجنسية",
          enName: "NationalityName",
          privateCompanyMode: true,
          type: "request",
          api: "api/Nationalities",
          values: null,
        },
        {
          arabicName: "نوع الجنسية",
          enName: "NationalityTypeString",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "وطني",
              value: "وطني",
            },
            {
              title: "أجنبي",
              value: "أجنبي",
              // value: "أجنبي",
            },
          ],
        },
        {
          arabicName: "شهر العلاوة",
          enName: "BonusDueDate",
          privateCompanyMode: false,
          type: "enum",
          values: [
            {
              title: "1",
              value: "1",
            },
            {
              title: "2",
              value: "2",
            },
            {
              title: "3",
              value: "3",
            },
            {
              title: "4",
              value: "4",
            },
            {
              title: "5",
              value: "5",
            },
            {
              title: "6",
              value: "6",
            },
            {
              title: "7",
              value: "7",
            },
            {
              title: "8",
              value: "8",
            },
            {
              title: "9",
              value: "9",
            },
            {
              title: "10",
              value: "10",
            },
            {
              title: "11",
              value: "11",
            },
            {
              title: "12",
              value: "12",
            },
          ],
        },
        // {
        //   arabicName: "الرقم الالي لجواز السفر",
        //   enName: "PassportAutoNumber",
        // privateCompanyMode: true,
        //   type: "number",
        //   values: null,
        // },
        {
          arabicName: "رقم البطاقة الشخصية",
          enName: "IdentificationCardNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        // {
        //   arabicName: "مكان اصدارالبطاقة الشخصية ",
        //   enName: "IdentificationCardIssuePlace",
        // privateCompanyMode: true,
        //   type: "text",
        //   values: null,
        // },
        // {
        //   arabicName: "تاريخ اصدارالبطاقة الشخصية ",
        //   enName: "IdentificationCardIssueDate",
        // privateCompanyMode: true,
        //   type: "fromTo",
        //   values: null,
        // },
        {
          arabicName: "رقم كتيب العائلة",
          enName: "BookletNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        // {
        //   arabicName: "مكان اصدار كتيب العائلة ",
        //   enName: "BookletIssuePlace",
        // privateCompanyMode: true,
        //   type: "text",
        //   values: null,
        // },
        // {
        //   arabicName: "تاريخ اصدار كتيب العائلة",
        //   enName: "BookletIssueDate",
        // privateCompanyMode: true,
        //   type: "fromTo",
        //   values: null,
        // },
        {
          arabicName: "رقم ورقة العائلة",
          enName: "BookletFamilyNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "رقم القيد",
          enName: "BookletRegistrationFamilyNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "السجل المدني المسؤول",
          enName: "BookletCivilRegister",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        // {
        //   arabicName: "البريد الالكتروني",
        //   enName: "Email",
        // privateCompanyMode: true,
        //   type: "text",
        //   values: null,
        // },
        {
          arabicName: "عدد الاطفال ",
          enName: "ChilderCount",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "جنسية الزوجة",
          enName: "NationalityMarriedString",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "ليبية",
              value: "ليبية",
            },
            {
              title: "اجنبية",
              value: "اجنبية",
            },
          ],
        },
        // {
        //   arabicName: "اسم الزوجة",
        //   enName: "NameMarried",
        // privateCompanyMode: true,
        //   type: "text",
        //   values: null,
        // },
        {
          arabicName: "الحالة الاجتماعية",
          enName: "SocialStatusString",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "اعزب",
              value: "اعزب",
            },
            {
              title: "متزوج/ة",
              value: "متزوج/ة",
            },
            {
              title: "مطلق/ة",
              value: "مطلق/ة",
            },
            {
              title: "متزوج ويعول",
              value: "متزوج ويعول",
            },
            {
              title: "ارملة",
              value: "ارملة",
            },
            {
              title: "ارملة وتعول",
              value: "ارملة وتعول",
            },
            {
              title: "ارمل",
              value: "ارمل",
            },
          ],
        },
        {
          arabicName: "اسم الام",
          enName: "MotherName",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "مكان الميلاد",
          enName: "BirthPlace",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "تاريخ الميلاد",
          enName: "BirthDate",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "تاريخ انتهاء صلاحية التأشيرة",
          enName: "VisaExpiryDate",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "رقم الهاتف",
          enName: "Phone",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "العنوان",
          enName: "Address",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },

        {
          arabicName: "الجنس",
          enName: "GenderString",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "ذكر",
              value: "ذكر",
            },
            {
              title: "انثى",
              value: "انثى",
            },
          ],
        },

        {
          arabicName: "الرقم الوطني ",
          enName: "NationalNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "رقم الموظف",
          enName: "JobNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "رقم الملف الشخصي",
          enName: "ProfileNumber",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "رقم الملاك الوظيفي",
          enName: "EmploymentNumber",
          privateCompanyMode: false,
          type: "number",
          values: null,
        },

        {
          arabicName: "الوضع الحالي",
          enName: "CurrentSituationString",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "تاريخ المباشرة",
          enName: "StartingDate",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "تاريخ التعاقد",
          enName: "EmploymentDate",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "تاريخ بداية العقد",
          enName: "ContractDateFrom",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "تاريخ نهاية العقد",
          enName: "ContractDateTo",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "الزيادة الشهرية للاجازة السنوية",
          enName: "MonthlyIncreaseOfVacation",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
        {
          arabicName: "الوظيفة",
          enName: "Job",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "مكان العمل",
          enName: "Workplace",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "الدرجة الحالية",
          enName: "CurrentGradeString",
          privateCompanyMode: false,
          type: "enum",
          values: [
            {
              title: "الدرجة الاولى",
              value: "الدرجة الاولى",
            },
            {
              title: "الدرجة الثانية",
              value: "الدرجة الثانية",
            },
            {
              title: "الدرجة الثالثة",
              value: "الدرجة الثالثة",
            },
            {
              title: "الدرجة الرابعة",
              value: "الدرجة الرابعة",
            },
            {
              title: "الدرجة الخامسة",
              value: "الدرجة الخامسة",
            },
            {
              title: "الدرجة السادسة",
              value: "الدرجة السادسة",
            },
            {
              title: "الدرجة السابعة",
              value: "الدرجة السابعة",
            },

            {
              title: "الدرجة الثامنة",
              value: "الدرجة الثامنة",
            },

            {
              title: "الدرجة التاسعة",
              value: "الدرجة التاسعة",
            },

            {
              title: "الدرجة العاشرة",
              value: "الدرجة العاشرة",
            },

            {
              title: "الدرجة الحادية عشر",
              value: "الدرجة الحادية عشر",
            },

            {
              title: "الدرجة الثانية عشر",
              value: "الدرجة الثانية عشر",
            },

            {
              title: "الدرجة الثالثة عشر",
              value: "الدرجة الثالثة عشر",
            },

            {
              title: "الدرجة الرابعة عشر",
              value: "الدرجة الرابعة عشر",
            },

            {
              title: "الدرجة الخامسة عشر",
              value: "الدرجة الخامسة عشر",
            },

            {
              title: "الدرجة السادسة عشر",
              value: "الدرجة السادسة عشر",
            },
          ],
        },
        {
          arabicName: "سبب الدرجة الحالية",
          enName: "ReasonForCurrentGradeString",
          privateCompanyMode: false,
          type: "text",
          values: null,
        },
        {
          arabicName: "العلاوة الادارية",
          enName: "CurrentBonus",
          privateCompanyMode: false,
          type: "enum",
          values: [
            {
              title: "0",
              value: "0",
            },

            {
              title: "1",
              value: "1",
            },
            {
              title: "2",
              value: "2",
            },
            {
              title: "3",
              value: "3",
            },
            {
              title: "4",
              value: "4",
            },
            {
              title: "5",
              value: "5",
            },
            {
              title: "6",
              value: "6",
            },
            {
              title: "7",
              value: "7",
            },
            {
              title: "8",
              value: "8",
            },
            {
              title: "9",
              value: "9",
            },
            {
              title: "10",
              value: "10",
            },
          ],
        },

        {
          arabicName: "تاريخ الدرجة الحالية",
          enName: "LastGradeUpdate",
          privateCompanyMode: false,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "تاريخ استحقاق الترقية",
          enName: "UpgradeDueDate",
          privateCompanyMode: false,
          type: "fromTo",
          values: null,
        },
        // {
        //   arabicName: "الصفة الوظيفية",
        //   enName: "JobTitle",
        // privateCompanyMode: true,
        //   type: "request",
        //   api: "api/JobTitle",
        //   values: null,
        // },
        {
          arabicName: "المؤهل العلمي",
          enName: "ScientificDegreeName",
          privateCompanyMode: true,
          type: "request",
          api: "api/qualifications",
          values: null,
        },
        {
          arabicName: "التخصص",
          enName: "Specialization",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "جهة اصدار المؤهل العلمي",
          enName: "CertificateProviderOrganization",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "سنة الحصول على المؤهل العلمي",
          enName: "ScientificDegreeYear",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "تاريخ قرار التعيين",
          enName: "EmploymentDate",
          privateCompanyMode: false,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "رقم قرار التعيين",
          enName: "DesignationDecisionNumber",
          privateCompanyMode: false,
          type: "text",
          values: null,
        },
        {
          arabicName: "جهة اصدار التعيين",
          enName: "Appointment",
          privateCompanyMode: false,
          type: "text",
          values: null,
        },
        {
          arabicName: "الوضع الوظيفي عند التعيين",
          enName: "JobStatusAppointment",
          privateCompanyMode: false,
          type: "text",
          values: null,
        },
        {
          arabicName: "المؤهل العلمي عند التعيين",
          enName: "ScientificAppointment",
          privateCompanyMode: false,
          type: "text",
          values: null,
        },

        {
          arabicName: "الدرجة عند التوظيف",
          enName: "GradeAppointment",
          privateCompanyMode: false,
          type: "enum",
          values: [
            {
              title: "الدرجة الاولى",
              value: "الدرجة الاولى",
            },
            {
              title: "الدرجة الثانية",
              value: "الدرجة الثانية",
            },
            {
              title: "الدرجة الثالثة",
              value: "الدرجة الثالثة",
            },
            {
              title: "الدرجة الرابعة",
              value: "الدرجة الرابعة",
            },
            {
              title: "الدرجة الخامسة",
              value: "الدرجة الخامسة",
            },
            {
              title: "الدرجة السادسة",
              value: "الدرجة السادسة",
            },
            {
              title: "الدرجة السابعة",
              value: "الدرجة السابعة",
            },

            {
              title: "الدرجة الثامنة",
              value: "الدرجة الثامنة",
            },

            {
              title: "الدرجة التاسعة",
              value: "الدرجة التاسعة",
            },

            {
              title: "الدرجة العاشرة",
              value: "الدرجة العاشرة",
            },

            {
              title: "الدرجة الحادية عشر",
              value: "الدرجة الحادية عشر",
            },

            {
              title: "الدرجة الثانية عشر",
              value: "الدرجة الثانية عشر",
            },

            {
              title: "الدرجة الثالثة عشر",
              value: "الدرجة الثالثة عشر",
            },

            {
              title: "الدرجة الرابعة عشر",
              value: "الدرجة الرابعة عشر",
            },

            {
              title: "الدرجة الخامسة عشر",
              value: "الدرجة الخامسة عشر",
            },

            {
              title: "الدرجة السادسة عشر",
              value: "الدرجة السادسة عشر",
            },
          ],
        },
        // {
        //   arabicName: "التخصص عند التعيين",
        //   enName: "ScientificAppointment",
        // privateCompanyMode: true,
        //   type: "text",
        //   values: null,
        // },
        {
          arabicName: "تاريخ شغل الوظيفية",
          enName: "StartingDateAtWorkToString",
          privateCompanyMode: true,
          type: "fromTo",
          values: null,
        },
        {
          arabicName: "جهة العمل السابقة",
          enName: "PreviousEmployer",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "الكفاءة السنوية 1",
          enName: "EfficiencyString",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "الكفاءة السنوية 2",
          enName: "EfficiencyTwoString",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "الكفاءة السنوية 3",
          enName: "EfficiencyThreeString",
          privateCompanyMode: true,
          type: "text",
          values: null,
        },
        {
          arabicName: "رصيد الأجازة السنوية",
          enName: "YearlyVecationBalance",
          privateCompanyMode: true,
          type: "number",
          values: null,
        },
      ],
    };
  },
  created() {
    const styleValue = localStorage.getItem("privateCompanyMode");
    this.privateCompanyMode = styleValue === "true";
  },
  methods: {
    increaseToForm() {
      this.repeaterForm.push({
        filter: "",
        value: null,
        value2: new Date(),
      });
    },
    removeFromForm(index) {
      if (index > 0) {
        this.repeaterForm.splice(index, 1);
      }
    },
    async fetchData(item) {
      // console.warn("item", item);

      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);

      let { data } = await axios.get(`${env.HR()}/${item.filter.api}`, {
        headers: { Authorization: "Bearer " + token },
      });

      const find = this.col_pdf.find((x) => x.enName == item.filter.enName);

      // console.warn("find", find);
      find.values = data.data;

      // console.warn("data", data);
    },

    convert(event) {
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "-";
        }
        return formattedDate;
      } catch (error) {}
    },

    search() {
      const filter = this.formatFilterData();

      this.$emit("search", filter);
    },

    printExcel() {
      const filter = this.formatFilterData();

      this.$emit("excel", filter);
    },

    printPdf() {
      const filter = this.formatFilterData();

      this.$emit("pdf", filter);
    },

    formatFilterData() {
      const filter = this.repeaterForm.map((item) => {
        const { type, enName } = item.filter;
        const value =
          type === "fromTo"
            ? `${this.convert(item.value)},${this.convert(item.value2)}`
            : item.value;

        return { key: enName, value };
      });

      if (filter.length === 1 && filter[0].value === null) {
        return [];
      }

      return filter;
    },

    clear() {
      (this.repeaterForm = [
        {
          filter: "",
          value: null,
          value2: null,
        },
      ]),
        this.$emit("empty");
    },
  },

  watch: {
    repeaterForm: {
      deep: true,
      handler(newValue, oldValue) {
        const lastItem = newValue[newValue.length - 1];
        // console.warn("newValue", newValue);

        if (lastItem.filter.type == "request" && !lastItem.filter.values) {
          this.fetchData(lastItem);
          // console.warn("lastItem", lastItem);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.card-content-flex {
  display: flex;
  gap: 40px;
}

.date-from-to {
  width: 100%;
  display: flex;
  gap: 40px;

  .md-layout-item {
    // width: 50%;
    // flex: auto;
  }
}
</style>